// extracted by mini-css-extract-plugin
export default {"card":"BackgroundForm_card__-Bd6q","content":"BackgroundForm_content__cxacm"};